import { Result } from "antd";
import React from "react";

export default function ResultWarning() {
  return <Result status="warning" title="Новых данных нет" />;
}
